import { SHOW_IN_PHIEU_THUCHI } from "actions/InThuChi/actionTypes";
import {
  GET_DETAIL_PHIEU_THUCHI,
  GET_DETAIL_PHIEU_THUCHI_SUCCESS,
  GET_DETAIL_PHIEU_THUCHI_FAILURE,
  GET_IN_PHIEU_THUCHI,
  GET_IN_PHIEU_THUCHI_SUCCESS,
  GET_IN_PHIEU_THUCHI_FAILURE,
} from "actions/InThuChi/actionTypes";

const initialState = {
  inChoVayLoading: false,
  DetailPhieuThuChi: {},
  InPhieuThuChi: "",
  inThuChiShow: false,
  thuChiId: 0,
};

const getDetailPhieuThuChi = (state, action) => ({
  ...state,
  inChoVayLoading: true,
});

const getDetailPhieuThuChiSuccess = (state, action) => {
  return {
    ...state,
    inChoVayLoading: false,
    DetailPhieuThuChi: action.payload,
  };
};

const getDetailPhieuThuChiFailed = (state, action) => ({
  ...state,
  inChoVayLoading: false,
  DetailPhieuThuChi: [],
});

const getInPhieuThuChi = (state, action) => ({
  ...state,
  inChoVayLoading: true,
});

const getInPhieuThuChiSuccess = (state, action) => {
  return {
    ...state,
    inChoVayLoading: false,
    InPhieuThuChi: action.payload,
  };
};

const getInPhieuThuChiFailed = (state, action) => ({
  ...state,
  inChoVayLoading: false,
  InPhieuThuChi: "",
});
const showInPhieuThuChi = (state, action) => ({
  ...state,
  inThuChiShow: !state.inThuChiShow,
  thuChiId: action.thuChiId,
});
const inChoVayReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DETAIL_PHIEU_THUCHI:
      return getDetailPhieuThuChi(state, action);
    case GET_DETAIL_PHIEU_THUCHI_SUCCESS:
      return getDetailPhieuThuChiSuccess(state, action);
    case GET_DETAIL_PHIEU_THUCHI_FAILURE:
      return getDetailPhieuThuChiFailed(state, action);
    case GET_IN_PHIEU_THUCHI:
      return getInPhieuThuChi(state, action);
    case GET_IN_PHIEU_THUCHI_SUCCESS:
      return getInPhieuThuChiSuccess(state, action);
    case GET_IN_PHIEU_THUCHI_FAILURE:
      return getInPhieuThuChiFailed(state, action);
    case SHOW_IN_PHIEU_THUCHI:
      return showInPhieuThuChi(state, action);
    default:
      return state;
  }
};

export default inChoVayReducer;
